import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { TabTitleProp } from './TabNavigationItem';

// used by tab navigation to render tabnavgationitem
const TabNavigationContent: FunctionComponent<React.PropsWithChildren<TabTitleProp>> = ({ children }) => (
    <TabWrapper>{children}</TabWrapper>
);

const TabWrapper = styled.div``;

export default TabNavigationContent;
